import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ValidateShield = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M11.0694 5.98809L9.93056 5.01191L7.38786 7.97839L5.95 6.9L5.05 8.1L7.61214 10.0216L11.0694 5.98809Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 3.5V9.73616C2.5 10.2161 2.72963 10.667 3.11774 10.9493L7.11774 13.8584C7.64372 14.2409 8.35628 14.2409 8.88226 13.8584L12.8823 10.9493C13.2704 10.667 13.5 10.2161 13.5 9.73616V3.5C13.5 2.67157 12.8284 2 12 2H4C3.17157 2 2.5 2.67157 2.5 3.5ZM4 9.73616V3.5L12 3.5V9.73616L8 12.6453L4 9.73616Z"
      fill="currentColor"
    />
  </Icon>
));

export default ValidateShield;
